import { PrescricaoPDFsMesParmDTO } from "@/interfaces/prescriptions-month-pdfs";
import { ENDPOINTS } from "@/settings/api-settings";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";


export function listPrescriptionPDFsMonthFormats(): Observable<any> {
  return from(
    apiClient.get(ENDPOINTS.PRESCRIPTIONS_MONTH_PDFS_FORMATS),
  ).pipe(map((r: any) => r.data || {}));
}

export function listPrescriptionPDFsMonthMonths(): Observable<any> {
  return from(
    apiClient.get(ENDPOINTS.PRESCRIPTIONS_MONTH_PDFS_MONTHS),
  ).pipe(map((r: any) => r.data || {}));
}

export function savePrescriptionPDFsMonth(dto: PrescricaoPDFsMesParmDTO): Observable<any> {
  return from(
    apiClient.post(ENDPOINTS.PRESCRIPTIONS_MONTH_PDFS, dto),
  ).pipe(map((r: any) => r.data || {}));
}



